import React, { useEffect, useState } from 'react'

import { Dialog } from './styles'

export default function (props) {
  const [activeName, setActiveName] = useState('')

  useEffect(() => {
    setTimeout(() => setActiveName('dialog-active'), 100)
  }, [])

  return (
    <Dialog onClick={() => props.onClose()}>
      <div
        style={{ width: props.width || 500 }}
        className={`dialog-inner ${activeName}`}
        onClick={event => event.stopPropagation()}
      >
        <div className="dialog-title">
          {props.title || 'Title'}{' '}
          <i
            className="dialog-cancel icon-cancel"
            onClick={() => props.onClose()}
          />
        </div>
        <div className="dialog-content">{props.children}</div>
      </div>
    </Dialog>
  )
}
